"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomPolarAnswerWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var journey_services_1 = require("@athena-portal/journey-services");
var journey_model_1 = require("@athena-portal/journey-model");
var Types_1 = require("../Types");
var core_1 = require("@athena-portal/core");
var CustomPolarAnswerWidget = /** @class */ (function (_super) {
    __extends(CustomPolarAnswerWidget, _super);
    function CustomPolarAnswerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.interactionFieldPositive = _this.getSetting("interactionField", undefined);
        var positiveAnswer;
        if (_this.interactionFieldPositive) {
            positiveAnswer = journey_services_1.ObjectManipulator.fetchFieldValue(_this.interactionFieldPositive, _this.props.interaction);
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is missing 'interactionField' setting"));
        }
        var checkedYes;
        var checkedNo;
        if (positiveAnswer == null) {
            checkedYes = false;
            checkedNo = false;
        }
        else {
            checkedYes = positiveAnswer;
            checkedNo = !positiveAnswer;
        }
        _this.state = {
            positiveAnswer: Boolean(positiveAnswer),
            informationHidden: true,
            checkedYes: checkedYes,
            checkedNo: checkedNo
        };
        _this.handleOnChangeEvent = _this.handleOnChangeEvent.bind(_this);
        _this.clickInfoButton = _this.clickInfoButton.bind(_this);
        return _this;
    }
    CustomPolarAnswerWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { className: "form-group ".concat(this.state.informationHidden ? "" : "background-color-grey inner-content negative-margin width-auto"), children: [(0, jsx_runtime_1.jsxs)("div", { className: "row custom-polar-panel-text pt-3", children: [(0, jsx_runtime_1.jsx)("label", { className: "col-10 pl-0", htmlFor: this.getSetting("name"), children: this.props.question.label }), (0, jsx_runtime_1.jsx)("span", { className: "col-2", children: this.state.informationHidden ?
                                (0, jsx_runtime_1.jsx)("div", { className: "info-button", tabIndex: 0, "aria-label": "Show additional information", onClick: this.clickInfoButton }) :
                                (0, jsx_runtime_1.jsx)("div", { className: "info-button selected", tabIndex: 0, "aria-label": "Hide additional information", onClick: this.clickInfoButton }) })] }), !this.state.informationHidden &&
                    (0, jsx_runtime_1.jsx)("div", { className: "info-button-panel", children: this.getSetting("hiddenInfoText") }), (0, jsx_runtime_1.jsxs)("div", { className: "input-group", role: "group", "aria-label": "Do you want to cover another car?", children: [(0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { id: "".concat(this.getSetting("name", ""), "-true"), className: "custom-control-input null", type: "radio", name: this.getSetting("name"), value: "true", checked: this.state.checkedYes, onChange: this.handleOnChangeEvent }), (0, jsx_runtime_1.jsx)("label", { id: "custom-polar-yes-button", className: "custom-control-label", htmlFor: "".concat(this.getSetting("name", ""), "-true"), children: "Yes" })] }), (0, jsx_runtime_1.jsxs)("div", { className: "custom-control custom-radio", children: [(0, jsx_runtime_1.jsx)("input", { id: "".concat(this.getSetting("name", ""), "-false"), className: "custom-control-input null}", type: "radio", name: this.getSetting("name"), value: "false", checked: this.state.checkedNo, onChange: this.handleOnChangeEvent }), (0, jsx_runtime_1.jsx)("label", { id: "custom-polar-no-button", className: "custom-control-label", htmlFor: "".concat(this.getSetting("name", ""), "-false"), children: "No" })] })] })] }));
    };
    CustomPolarAnswerWidget.prototype.clickInfoButton = function () {
        this.setState(function (prevState) { return ({
            informationHidden: !prevState.informationHidden
        }); });
    };
    CustomPolarAnswerWidget.prototype.handleOnChangeEvent = function (event) {
        var positiveAnswer = event.target.value === "true";
        this.props.onStateChange(this.props.question.interactionField, positiveAnswer);
        this.setState({
            positiveAnswer: positiveAnswer,
            checkedYes: positiveAnswer,
            checkedNo: !positiveAnswer
        });
        // Execute native event to allow onChange event to be captured in journey
        this.executeNativeEvent(event);
        this.changelogRecorder.recordQuestion("event", this.props);
    };
    __decorate([
        (0, core_1.lazyInject)(Types_1.Types.ChangelogRecorder),
        __metadata("design:type", Object)
    ], CustomPolarAnswerWidget.prototype, "changelogRecorder", void 0);
    CustomPolarAnswerWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "interactionField", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], CustomPolarAnswerWidget);
    return CustomPolarAnswerWidget;
}(plugin_journey_1.WidgetBase));
exports.CustomPolarAnswerWidget = CustomPolarAnswerWidget;
//# sourceMappingURL=CustomPolarAnswerWidget.js.map